import { createI18nPack } from '@mapado/i18next-pack';

// declare your configuration
const projectName = 'seating';
const namespaceList = ['admin'];

const defaultNamespace = 'main';
const languageList = ['fr', 'en', 'de'];
const defaultLanguage = 'fr';

// This function load the local JSON files in case the translation server is down
// We need to keep the full path name and do not use template strings as rollup wont resolve path
function backendLoader(
  language: string,
  namespace: string
): Promise<Record<string, unknown>> {
  if (namespace === 'admin') {
    switch (language) {
      case 'fr':
        return import('../locales/fr/admin.json');
      case 'en':
        return import('../locales/en/admin.json');
      case 'de':
        return import('../locales/de/admin.json');

      default:
        return Promise.reject(new Error(`Do not handle locale ${language}`));
    }
  }

  throw new Error('Namespace must be "admin"');
}

const { useTranslation } = createI18nPack(
  projectName,
  namespaceList,
  defaultNamespace,
  languageList,
  defaultLanguage,
  backendLoader
);

export { useTranslation };
